module.exports = __webpack_public_path__ + "img/ic-my-profile-others.ad0e59ba.png";